import {useReportErrorContext} from '@github-ui/react-core/future/report-error-context'
import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useEffect, useEffectEvent} from 'react'
import {allWorkflowRunsRoute} from './all-workflow-runs-route'
import {WorkflowRunsPage} from '../components/workflow-runs/WorkflowRunsPage'
import {WorkflowLoadError} from './workflow-runs'

export function AllWorkflowRuns() {
  const {owner, repo} = useRouteParams(allWorkflowRunsRoute)
  const workflowRunsQuery = useRouteQuery(allWorkflowRunsRoute, 'mainQuery', {
    placeholderData: previousData => previousData,
  })

  const reportError = useReportErrorContext()
  const backgroundError = workflowRunsQuery.data !== undefined ? workflowRunsQuery.error : null
  const reportBackgroundError = useEffectEvent(() => {
    if (backgroundError) reportError(backgroundError, {critical: false})
  })

  useEffect(() => {
    reportBackgroundError()
  }, [backgroundError])

  if (workflowRunsQuery.isError && workflowRunsQuery.data === undefined) throw workflowRunsQuery.error

  return (
    <WorkflowRunsPage
      key={`${owner}/${repo}/all`}
      owner={owner}
      repo={repo}
      workflowRunsQueryKey={workflowRunsQuery.queryKey}
      workflowRuns={workflowRunsQuery.data?.workflowRuns}
      totalPages={workflowRunsQuery.data?.totalPages}
      totalCount={workflowRunsQuery.data?.totalCount}
      countIsCapped={workflowRunsQuery.data?.countIsCapped}
      pageLimitReached={workflowRunsQuery.data?.pageLimitReached}
      loading={workflowRunsQuery.isFetching}
      showingPreviousResults={workflowRunsQuery.isPlaceholderData}
      workflowRunActionsEnabled={!workflowRunsQuery.isPlaceholderData}
      aliveChannel={workflowRunsQuery.data?.aliveChannel}
    />
  )
}

export function AllWorkflowRunsError() {
  return <WorkflowLoadError showAllWorkflowsAction={false} />
}
